module.exports = __webpack_public_path__ + "static/media/reward-red.450cf1f9.svg";